import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import toast from 'react-simple-toasts';
import { useLocation } from 'react-router-dom';
import generatePDF from 'react-to-pdf';
import BaseUrl from '../../BaseUrl';

const ViewQuotation = () => {
  const location = useLocation();
  const { id } = location.state;
  const targetRef = useRef();

  const [data, setData] = useState({});
  const [planData, setPlanData] = useState({});

  useEffect(() => {
    axios
      .get(`${BaseUrl.baseUrl}/quotation/get/${id}`)
      .then((res) => {
        if (res.data.status === 'ok') {
          setData(res.data.data);
          axios
            .get(`${BaseUrl.baseUrl}/plan/${res.data.data?.plan_id}`)
            .then((res) => {
              if (res.data.status === 'ok') {
                setPlanData(res.data.plans);
              } else {
                toast('🚩' + res.data.message);
              }
            })
            .catch((err) => toast('🚨' + err.message));
        } else {
          toast('🚩' + res.data.message);
        }
      })
      .catch((err) => toast('🚨' + err.message));
  }, []);

   const getSetupFee = (input) => {
    const match = input?.match(/Setup Fee\s*\$([\d.]+)/i);
    return match ? parseFloat(match[1]) : 0;
  };

  return (
    <>
      <div className="d-flex justify-content-end px-4 py-3">
        <button
          className="btn btn-success rounded-pill px-4 py-2"
          onClick={() =>
            generatePDF(targetRef, {
              filename: `Invoice_${data?.id}.pdf`,
            })
          }
        >
          <i className="fa fa-download me-2" /> Download Invoice
        </button>
      </div>

      <div className="container" ref={targetRef}>
        <div className="bg-white rounded shadow-lg py-5">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-4">
            <div className='ps-5'>
              <img src={require('../../Assests/logo.png')} alt="Logo" width={180} />
              <p className="mt-2 mb-1 fw-bold">{data?.companyName}</p>
              <p className="mb-1">{data?.companyEmail}</p>
              <p className="mb-1">{data?.companyPhone}</p>
              <p className="mb-1">{data?.companyAddress}</p>
              {/* <p className="mb-1 text-primary">
                <a href="https://oncloudapi.com">https://oncloudapi.com</a>
              </p> */}
            </div>
            <div className="text-end w-50">
              <h5 className="bg-dark text-white px-3 py-2 text-start">RENEWAL INVOICE</h5>
              <div className='pe-5'>
                <div className='d-flex justify-content-between align-items-center my-3'>
                  <div>
                    <p className="">Invoice Date: {moment(data?.createdAt).format('DD/MM/YYYY')}</p>

                  </div>
                  <div>

                    <p className="">Due Date: {moment(data?.dueDate).format('DD/MM/YYYY')}</p>
                  </div>
                </div>
                <p className="mb-1 fw-semibold">Bill To: {data?.custName}</p>
                {/* <h6 className="mt-2 text-muted">#{data?.id}</h6> */}
              </div>
            </div>
          </div>

          {/* Section: WhatsApp API */}
          <div className="bg-dark text-white px-5 py-2 mb-3 fw-semibold d-flex justify-content-between align-items-center">
            <span>WHATSAPP BUSINESS API</span>
            <span className="">Cost</span>

          </div>

          <div className="row p-5 py-2">
            <div className="col-9">
              <h5 className="fw-semibold">1. {planData?.name} Package</h5>
              <ul className="mb-0">
                {planData?.features?.split(',').map((i, index) => (<li>{i}</li>))}
              </ul>
            </div>
            <div className="col-3 text-end position-relative">
              <h5 className="fw-bold">${planData?.price}</h5>

              <div className=" text-center my-4 pe-5 top-3 end-0" style={{ position: 'absolute',  }}>
                <img
                  src={data?.status==='Paid'?require('../../Assests/paid.png'):require('../../Assests/unpaid.jpg')} // replace this with the correct local stamp image path
                  alt="Paid Stamp"
                  style={{ width: 120 }}
                />
              </div>
            </div>
          </div>

          {/* Paid Stamp */}


          {/* Summary */}
          <div className="row justify-content-end p-5 py-3 w-full mt-5">
            <div className="col-md-12">
              <table className="table border-0 border-bottom-0">
                <tbody>
                  <tr className='fw-bold'>
                    <th className='border-bottom-0 text-end'>Sub Total</th>
                    <td className="text-end border-bottom-0">${planData?.price}</td>
                  </tr>
                  <tr className=' fw-bold'>
                    <th className='border-bottom-0 text-end'>Setup Fee</th>
                    <td className="text-end border-bottom-0">${getSetupFee(planData?.features)}</td>
                  </tr>
                  <tr className='bg-light fw-bold'>
                    <th className='border-bottom-0 text-end'>GST%</th>
                    <td className="text-end border-bottom-0">0</td>
                  </tr>
                  
                  <tr className="fw-bold">
                    <th className='border-bottom-0 text-end'>Total Amount</th>
                    <td className="text-end border-bottom-0">${(Number(planData?.price) + Number(getSetupFee(planData?.features)))?.toFixed(2)}/-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Bank Info */}
          <div className="mt-0 px-5">
            <p className="mb-1">Bank Name: Faysal Bank Limited</p>
            <p className="mb-1">Account Title: Wolf Software Solution Pvt Ltd</p>
            <p className="mb-1">Account no: PK08FAYS3419390000001092</p>
          </div>

          {/* Footer */}
          <div className="text-center mt-4">
            <small className="text-muted">
              This is a computer generated invoice that does not require a signature
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewQuotation;
